//Report recent list
import { createSelector } from "reselect";

const stats = (state: any) => state.statsReducer;

export const fetchRecentReports = createSelector(
  stats,
  (stats) => stats.recentReports
);
